import { css } from '@emotion/css';
import { id, SingleSelect } from 'Shared/forms/Inputs'
import { LabelOnLeftWrap, labelStyle } from 'Shared/forms/Wrap'
import { StoreProvider, useStore } from 'Shared/StoreProvider';
import { Sides } from 'Shared/backend/widgets/Sides';
import { paneIndentStyle } from 'Shared/backend/widgets/Styles';
import { createMemo } from 'solid-js';
import { splitLocation, subdoc } from 'Common/ViewUtils';
import { Amount } from 'Shared/forms/Amount';



//TODO may want/need a center option. Or perhaps rely on flex and/or grid

export function Margins(P)
{
	const gridStyle = css(paneIndentStyle(), {
		width: 0,
		display: 'grid',
		gridTemplateColumns: 'auto auto auto auto',
		columnGap: '1em',
		rowGap: '0.5em',

		'& > :nth-child(3)': {
			marginLeft: '3em'
		},
		'& > :nth-child(7)': {
			marginLeft: '3em'
		}
	});

	const sw = useStore();
	const defaults = () => undefined;

	return (
		<div>
			<Selector />

			<Sides
				label='Margins'
				property='margin'
				settings={MarginSettings}
				defaults={defaults}
				sides={subdoc(sw.store, sw.location ?? [])?.margin?.sides}
				style={gridStyle}
			/>
		</div>
	);
}

function MarginSettings(P:{label:string,name:string})
{
	const sw = useStore();

	const loc = createMemo(() => {
		const fullLocation = [...sw.location,'margin',P.name];
		const [location,field] = splitLocation(fullLocation);
		return {location:location,field:field};
	});

	return (
		<StoreProvider {...sw} location={loc().location}>
			<label class={labelStyle()} for={id(loc().field)}>{P.label}</label>

			<Amount field={loc().field} options={{em:'em',px:'px',percent:'%'}} />
		</StoreProvider>
	);
}

//TODO move
export function Selector()
{
	return (
		<LabelOnLeftWrap label='Element'>
			<SingleSelect field='selector' options={{self:'Self',children:'Children',all:'All'}} defaultValue='self' />
		</LabelOnLeftWrap>
	);
}

